module.exports = __webpack_public_path__ + "static/media/imaging-big-badge.469d9126.svg";